import BaseModel from '../core/BaseModel'
export default class UsersRoleModel extends BaseModel {

    constructor() {
        super({ 
                name: "user_role",
                tableName: 'core_user_role', 
                label: ""
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}